import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '../Base/Tabs';
import style from '@src/js/Style';
import SkeletonText from '../Skeleton/SkeletonText';
import AdaptiveTrait from '../../AdaptiveTrait';
import MortgageCompareBlock from './MortgageCompareBlock';

export default class MortgageCompare extends React.Component
{
    constructor(props) {

        super(props);

        this.state = {
            title: props.title ?? null,
            subtitle: props.subtitle ?? null,
            tab0: null,
            tab1: null,
            tab2: null,
            tab3: null,
            textBlock: {
                title: null,
                subtitle: null,
                paymentBadge: null,
                firstBenefit: null,
                secondBenefit: null,
            },
            chartBlock: {
                title: null,
                subtitle: null,
                mortgageLabel: null,
                rentLabel: null,
                diffLabel: null,
            }
        };

        this.components = {
            tabs: React.createRef(),
        };
    }

    static get propTypes() {

        return {
            title: PropTypes.string,
            subtitle: PropTypes.string,
            hasTax: PropTypes.bool,
        };
    }

    setState(state) {

        if (state != null) {

            super.setState(state, () => {


                // dirty hack by mobile version
                const titles = {};
                let tabTitleExists = false;
                Object
                    .keys(state)
                    .forEach((key) => {
                        
                        const matches = key.match(/^tab(\d+)$/i);
                        if (matches && matches.length > 0) {

                            tabTitleExists = true;
                            titles[matches[1]] = state[key];
                        }
                    });

                if (tabTitleExists)
                    this.components.tabs.current.updateNavigation(titles);

                if (this.tabs != undefined) {

                    this.tabs.forEach((tab, id) => {
                        
                        const titleId = `tab${id}`;
                        if (state[titleId] != undefined && tab.props.title.ref?.current != undefined)
                            tab.props.title.ref.current.setState({ content: state[titleId] });

                        if (state.textBlock != undefined || state.chartBlock != undefined)
                            this.updateTabData(id, {});
                    });
                }
            });
        }
    }

    static mergeObjects() {

        const result = {};

        Array.from(arguments)
            .forEach((data) => {
            
                if (data != null) {

                    Object
                        .entries(data)
                        .forEach(([id, value]) => {
                            
                            if (value !== null && value !== undefined)
                                result[id] = value;
                        });
                }
            });

        return result;
    }

    updateTabData(id, { textBlock, chartBlock }) {

        const componentId = `compareBlock${id}`;
        if (this.components[componentId] == undefined)
            return console.error(`Tab ${id} not found`);
        
        const component = this.components[componentId];
        component.setState({
            textBlock: MortgageCompare.mergeObjects(this.state.textBlock, component.state.textBlock, textBlock),
            chartBlock: MortgageCompare.mergeObjects(this.state.chartBlock, component.state.chartBlock, chartBlock),
        });
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        return (
            <section>

                <div className={ style('text-center') }>
                    <SkeletonText className={ style('title2 mb-2') } rows={ AdaptiveTrait.isMobile() ? 2 : 1  }>
                        { this.state.title }
                    </SkeletonText>
                    
                    <SkeletonText rows={ AdaptiveTrait.isMobile() ? 5 : 2 } when={ () => !! this.state.subtitle }>
                        <div dangerouslySetInnerHTML={{ __html: this.state.subtitle }}></div>
                    </SkeletonText>
                </div>

                <Tabs ref={ this.components.tabs } id={ 'compare' } children={ this.renderTabs() } />
                
            </section>
        );
    }

    renderTabs() {

        if (this.tabs == undefined) {

            this.tabs = Array(4)
                .fill(null)
                .map((value, id) => this.renderTab(id));
        }

        return this.tabs;
    }

    renderTab(id) {

        const title = <SkeletonText
            ref={ React.createRef() }
            skeletonClassName={ style('fixed-size-x-160') } />;

        return (
            <div id={ `compareTab${id}` } title={ title }>
                <MortgageCompareBlock
                    hasTax={ this.props.hasTax }
                    ref={ (ref) => this.components[`compareBlock${id}`] = ref }
                    />
            </div>
        );
    }

}